import React, { useId } from "react";
import { ArrowRightIcon, CreditCardIcon } from "lucide-react";
import { offer } from "../data/offer";
import { ctaClasses } from "../utils/cta";
type PurchaseButtonProps = {
  label: string;
  className?: string;
};

// Final purchase buttons: go to checkout when offer.checkoutUrl is set.
export function PurchaseButton({
  label,
  className = ""
}: PurchaseButtonProps) {
  const noteId = useId();
  const currencyId = useId();
  const isReady = offer.checkoutUrl.trim().length > 0;
  const content = <>
      <span data-id="element-248" data-mp="vnqt2pfz4mur">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" strokeWidth={2.75} aria-hidden="true" data-id="element-249" data-mp="voaewh8qvve2" />
    </>;
  const currencyNote = <p id={currencyId} className="mb-3 flex items-center justify-center gap-1.5 whitespace-nowrap text-[11px] leading-none text-ink-soft/80 sm:text-xs md:text-[13px]" data-id="element-250" data-mp="lxpgouwzgsvo">
      <CreditCardIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-251" data-mp="1eftbo6c6ed7n" />
      <span data-id="element-252" data-mp="rww8nobdkgoe">Payment will be processed in your local currency.</span>
    </p>;
  if (isReady) {
    return <div className={className} data-id="element-253" data-mp="mycnvr8ipaxm">
        {currencyNote}
        <a href={offer.checkoutUrl} data-cta="checkout" aria-describedby={currencyId} className={ctaClasses} data-id="element-254" data-mp="mzw27cam5bwr">
          {content}
        </a>
      </div>;
  }
  return <div className={className} data-id="element-255" data-mp="wvz20bhzsygj">
      {currencyNote}
      <button type="button" disabled aria-describedby={`${currencyId} ${noteId}`} className={`${ctaClasses} cursor-not-allowed opacity-60`} data-id="element-256" data-mp="wufmwo82otgc">
        {content}
      </button>
      <p id={noteId} className="mt-2 text-center text-xs font-medium text-ink-soft" data-id="element-257" data-mp="16lilnjdj4wcg">
        Checkout opens very soon.
      </p>
    </div>;
}